<template>
    <div>
        <!-- CONTENT -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <b-field>
                    <b-switch v-model="component.content.attributes.survey">Survey Mode (Don't Grade)</b-switch>
                </b-field>
                <b-field>
                    <b-switch v-model="component.content.attributes.required">Require Question to be Answered Correct to Continue</b-switch>
                </b-field>
            </div>
        </b-collapse>

        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Question/Instructions</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <content-blocks :blocks="component.content.content.question"/>
            </div>

        </b-collapse>

        <!-- answers -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Answer Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content pr-5 ml-5 pl-2">
                <div v-for="a in component.content.content.answers" class="columns">
                    <div class="column"><b-input type="textarea" rows="2" v-model="a.key" placeholder="Define your key..."></b-input></div>
                    <div class="column"><b-input type="textarea" rows="4" v-model="a.answer" placeholder="Define your answer..."></b-input></div>
                    <div class="column is-narrow">
                        <b-button size="is-small" @click="removeQuestion(a)" class="ml-2"><i class="far fa-trash-alt"></i></b-button>
                    </div>
                </div>
                <hr/>
                <div class="mb-5 ml-2">
                    <b-button @click="addAnswer"><i class="fas fa-plus mr-2"></i>Add Answer</b-button>
                </div>
            </div>

        </b-collapse>

        <!-- response -->
        <b-collapse animation="slide" class="mb-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Question Response</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <h6>Correct</h6>
            <div class="content">
                <content-blocks :blocks="component.content.content.correct"/>
            </div>

            <h6>Incorrect</h6>
            <div class="content">
                <content-blocks :blocks="component.content.content.incorrect"/>
            </div>

        </b-collapse>
    </div>
</template>

<script>
    import ContentBlocks from "../ContentBlocks.vue";
    import { v4 as uuidv4 } from 'uuid';

    export default {
        components: {ContentBlocks},
        props: ['component'],
        methods: {
            addAnswer() {
                this.component.content.content.answers.push({
                    answer: '',
                    correct: false,
                    id: uuidv4()
                });
            },
            removeQuestion(q) {
                this.component.content.content.answers.splice(this.component.content.content.answers.indexOf(q), 1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
